import { Types } from "../actions/LocalizationDataActions";

const initialState = {
    excelList: [],
    uploadResponse: {},
};

export const LocalizationDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_EXCEL_LIST:
            return {
                ...state,
                excelList: action.payload || state.excelList,
            };
        case Types.LOCALIZATION_UPLOAD_FILE:
            return {
                ...state,
                uploadResponse: action.payload || state.uploadResponse,
            };
        default:
            return state;
    }
};
